import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  reExportedColors,
  EditModeButton,
  FeedbackSnackbar,
  Text,
  GoBackButton,
  SaveCancelButtons,
  AddIconButton
} from '../../../components/1elements'
import SelectTypeModal from './SelectTypeModal'
import {
  crudHeaderPermission
} from '../../../services/permissions/permissionHelper'

const GridWrapper = ({
  header,
  children,
  editMode,
  setEditMode,
  isSnackbarOpen,
  setIsSnackbarOpen,
  handleSave,
  addCallBack,
  containedEntityType,
  isGridDirty,
  typeToTypeDisplayName,
  listOfTypes,
  defaultType,
  entityTypeDisplayName,
  requireSubType
}) => {
  const classes = useStyles({ editMode, isGridDirty })
  const [isModalOpen, setIsModalOpen] = useState(false)
  const localAddClickHandler = () => {
    if (containedEntityType) {
      if (requireSubType) {
        setIsModalOpen(true)
      } else {
        addCallBack(containedEntityType, defaultType)
      }
    } else {
      setIsModalOpen(true)
    }
  }
  const continueAddEntityAfterTypeSelection = type => {
    if (requireSubType) {
      addCallBack(containedEntityType, type)
    } else {
      addCallBack(type)
    }
  }
  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Text className={classes.pageHeader}>{header}</Text>
        <div className={classes.headerButtonDiv}>
          {(crudHeaderPermission(header, 'update')) && <EditModeButton onEditMode={editMode} setOnEditMode={setEditMode} /> }
          {(crudHeaderPermission(header, 'create')) && <AddIconButton onImportClick={localAddClickHandler} /> }
          <GoBackButton className={classes.goBackButton} />
        </div>
      </div>
      <div className={classes.scrollableDiv}>{children}</div>
      {isGridDirty && (
        <div className={classes.buttonDiv}>
          <div className={classes.headerButtonDiv}>
            <SaveCancelButtons
              setOnEditMode={setEditMode}
              setConfirmModalOpen={handleSave}
            ></SaveCancelButtons>
          </div>
        </div>
      )}
      <FeedbackSnackbar
        snackbar={isSnackbarOpen}
        setSnackbar={setIsSnackbarOpen}
      />
      <SelectTypeModal
        entityTypeDisplayName={entityTypeDisplayName}
        isModalOpen={isModalOpen}
        defaultType={defaultType}
        setIsModalOpen={setIsModalOpen}
        typeToTypeDisplayName={typeToTypeDisplayName}
        listOfTypes={listOfTypes}
        continuationCallback={continueAddEntityAfterTypeSelection}
      />
    </div>
  )
}

export default GridWrapper

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    height: 'calc(100vh - 43px)'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '15px 0 30px'
  },
  scrollableDiv: {
    height: props => (props.editMode && props.isGridDirty ? '82%' : '95%'),
    overflowY: 'auto'
  },
  buttonDiv: {
    width: '100%',
    margin: '0',
    padding: 20,
    position: 'absolute',
    display: 'flex',
    justifyContent: 'space-between',
    bottom: -10,
    height: props => (props.editMode ? 'auto' : 0),
    opacity: props => (props.editMode ? 1 : 0),
    overflowY: props => (props.editMode ? 'visible' : 'hidden'),
    transition: 'height .25s, opacity .25s',
    paddingTop: 10,
    paddingRight: 30,
    boxShadow: '0px 0px 6px #00000029',
    '&>*': {
      margin: 5,
      width: '100%'
    }
  },
  resetButton: {
    margin: '5px auto 5px 0 !important'
  },
  goBackButton: {
    marginLeft: 20
  },
  pageHeader: {
    fontSize: '22px',
    fontWeight: 'bold',
    fontFamily: 'Lato',
    color: reExportedColors.TEXT ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
  },
  headerButtonDiv: {
    display: 'flex',
    alignItems: 'center'
  }
}))
